import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs'
import { finalize } from 'rxjs/operators';

import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    updateRecord,
    updateRecordFailure,
    updateRecordSuccess
} from './failed-emails.action';

import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { FailedEmailsTableService } from './failed-emails-table.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { RouterService } from 'src/app/core/services/router.service';
import { RootReducerState } from '..';
import { Store } from '@ngrx/store';


@Injectable()
export class FailedEmailsRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'failed-emails';
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.moduleTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: listData, total: total});

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'failed-email-category';
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.moduleTableService.allSelectionValues = new Set();
                        this.moduleTableService.loadRecords();
                        this.alertService.triggerAlert(response.message, "success");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error }))
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    
    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private moduleTableService: FailedEmailsTableService,
        private tableService: DatatableService,
        private helperService: HelperService
    ) { }

}